export class NoOrderSelector {
    constructor() {
        this.type = "NoOrder";
    }
    test(_target) {
        return false;
    }
}
